import React, { useState, useEffect, useRef } from 'react';
import styles from '../../styles/GeneracionCargosManualesStyles/GeneracionCargosManuales.module.css';
import { getAdeudosPendientes, eliminarCargo, formatearFecha, formatearMonto, getCategoriaByNombre, getCategoriasRecargo, getCiclosEscolares, recalcularBecaCargos } from '../../api/cargosManuales';
import axios from 'axios';
import { getConceptosActivos } from '../../api/cargosManuales';
import { calcularRecargoCategoria } from '../../api/recargos';

// import { getCategoriasRecargo } from '../../api/cargosManuales';

function PendingChargesSection({ studentId, onChargeDeleted, onSelectionChange, selectedCargosFromParent, cargosSum = 0, recargoMap = {}, fechaPago, onRecargosByIdChange, campusEsTeran = false }) {
    // Estado para conceptos y categorías
    const [conceptos, setConceptos] = useState([]);
    const [categoriasRecargo, setCategoriasRecargo] = useState([]);
    const [ciclosMap, setCiclosMap] = useState({});
    // Ref para evitar llamadas repetidas a onRecargosByIdChange que causan loops
    const prevMapaRef = useRef(null);

    // Cargar ciclos escolares al montar
    useEffect(() => {
      getCiclosEscolares()
        .then(data => {
          // DRF puede devolver { results: [...] } (paginado) o array plano
          const arr = Array.isArray(data) ? data
            : Array.isArray(data?.results) ? data.results
            : Array.isArray(data?.ciclos) ? data.ciclos
            : [];
          const map = {};
          // El serializer expone: id_ciclo_escolar y ciclo (= nombre_ciclo)
          arr.forEach(c => { map[c.id_ciclo_escolar] = c.ciclo || c.nombre_ciclo || c.nombre || `Ciclo ${c.id_ciclo_escolar}`; });
          setCiclosMap(map);
        })
        .catch(() => {});
    }, []);

    // Cargar conceptos y categorías al montar
    useEffect(() => {
        async function fetchConceptosYCategorias() {
          try {
            // Conceptos activos
            const dataConceptos = await getConceptosActivos({ campus: 2 });
            let conceptosArr = Array.isArray(dataConceptos) ? dataConceptos : (Array.isArray(dataConceptos.conceptos) ? dataConceptos.conceptos : []);
            setConceptos(conceptosArr);
            // Categorías de recargo
            const dataCategorias = await getCategoriasRecargo();
            let categoriasArr = Array.isArray(dataCategorias) ? dataCategorias : (Array.isArray(dataCategorias.categorias) ? dataCategorias.categorias : []);
            // Normalizar y asegurar que exista un campo numérico `monto_cargo`
            categoriasArr = categoriasArr.map(cat => {
              const posibles = [cat.monto_cargo, cat.montoCargo, cat.monto, cat.montoRecargo, cat.monto_recargo, cat.montoCargoNum];
              let monto = undefined;
              for (const v of posibles) {
                if (v !== undefined && v !== null && v !== '') { monto = v; break; }
              }
              // intentar buscar claves que contengan 'monto' y 'cargo'
              if ((monto === undefined || monto === '' || isNaN(Number(monto)))) {
                for (const k of Object.keys(cat)) {
                  if (k.toLowerCase().includes('monto') && k.toLowerCase().includes('cargo')) {
                    monto = cat[k];
                    break;
                  }
                }
              }
              const montoNum = isNaN(Number(monto)) ? 0 : Number(monto);
              return { ...cat, monto_cargo: montoNum };
            });
            setCategoriasRecargo(categoriasArr);
          } catch (e) {
            console.error('Error cargando conceptos/categorías:', e);
            setConceptos([]);
            setCategoriasRecargo([]);
          }
        }
        fetchConceptosYCategorias();
    }, []);
  const [adeudos, setAdeudos] = useState([]);
  const [loading, setLoading] = useState(false);
  const [recalculating, setRecalculating] = useState(false);

  const handleRecalcularBecas = async () => {
    if (!studentId) return;
    setRecalculating(true);
    setError(null);
    try {
      const response = await recalcularBecaCargos(studentId);
      if (response.success) {
        alert(response.message || 'Se recalcularon los descuentos de becas correctamente.');
        await loadAdeudos(); // Recargar la lista de adeudos pendientes
        // Notificar al componente padre de cambios (para refrescar balances e importes totales)
        if (onChargeDeleted) {
          onChargeDeleted(null);
        }
      } else {
        setError(response.error || 'Error al recalcular descuentos de becas');
      }
    } catch (err) {
      console.error('Error al recalcular becas:', err);
      setError(err.message || 'Error al recalcular descuentos de becas');
    } finally {
      setRecalculating(false);
    }
  };

  const [error, setError] = useState(null);
  const [deletingId, setDeletingId] = useState(null);
  
  // Estado para persistir los montos ingresados (no se pierden al deseleccionar)
  const montosIngresadosRef = useRef({});
  
  // Usar los cargos seleccionados del padre si están disponibles, sino usar estado local
  const [localSelectedCargos, setLocalSelectedCargos] = useState([]);
  const selectedCargos = selectedCargosFromParent !== undefined ? selectedCargosFromParent : localSelectedCargos;
  const setSelectedCargos = selectedCargosFromParent !== undefined 
    ? (newSelection) => {
        // Si el padre controla la selección, notificar el cambio
        if (onSelectionChange) {
          const newValue = typeof newSelection === 'function' ? newSelection(selectedCargos) : newSelection;
          onSelectionChange(newValue, adeudos);
        }
      }
    : setLocalSelectedCargos;

  // Cargar adeudos pendientes al montar o cuando cambia el estudiante
  useEffect(() => {
    if (studentId) {
      loadAdeudos();
    }
  }, [studentId]);

  // Si las categorías o la fecha de pago cambian, recargar adeudos para recalcular recargos
  useEffect(() => {
    if (studentId && (categoriasRecargo.length > 0) ) {
      // reload adeudos so monto_recargo se recalcula en loadAdeudos
      loadAdeudos();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [categoriasRecargo, fechaPago]);

  // Exponer la lista de adeudos pendientes y categorías de recargo globalmente para ChargeForm
  useEffect(() => {
    if (typeof window !== 'undefined') {
      window.__lastAdeudosPendientes = adeudos;
      window.__lastCategoriasRecargo = categoriasRecargo;
    }
  }, [adeudos, categoriasRecargo]);

  // Notificar cambios en la selección al componente padre (solo si usamos estado local)
  useEffect(() => {
    if (selectedCargosFromParent === undefined && onSelectionChange) {
      onSelectionChange(localSelectedCargos, adeudos);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [localSelectedCargos]);

  // Funciones para selección de cargos (mantiene persistencia de montos)
  const handleCargoSelection = (cargoId, saldoPendiente) => {
    const exists = selectedCargos.find(c => c.id_cargo === cargoId);
    
    if (exists) {
      // Al deseleccionar, guardar el monto actual para persistencia
      montosIngresadosRef.current[cargoId] = exists.monto_aplicado;
      setSelectedCargos(selectedCargos.filter(c => c.id_cargo !== cargoId));
    } else {
      // Al seleccionar, recuperar el monto guardado o usar el saldo pendiente
      const montoGuardado = montosIngresadosRef.current[cargoId];
      const montoAUsar = montoGuardado !== undefined ? montoGuardado : parseFloat(saldoPendiente);
      
      setSelectedCargos([...selectedCargos, {
        id_cargo: cargoId,
        monto_aplicado: montoAUsar
      }]);
    }
  };

  const handleMontoAplicadoChange = (cargoId, nuevoMonto, saldoPendiente) => {
    const montoNumerico = parseFloat(nuevoMonto) || 0;
    // No permitir que el monto exceda el saldo pendiente
    const montoValido = Math.min(montoNumerico, parseFloat(saldoPendiente));
    const montoFinal = Math.max(0, montoValido);
    
    // Guardar en el ref para persistencia
    montosIngresadosRef.current[cargoId] = montoFinal;
    
    setSelectedCargos(selectedCargos.map(c => 
      c.id_cargo === cargoId 
        ? { ...c, monto_aplicado: montoFinal }
        : c
    ));
  };

  const loadAdeudos = async () => {
    setLoading(true);
    setError(null);
    try {
      const response = await getAdeudosPendientes(studentId);
      let adeudosRaw = response.adeudos || [];
      
      // Si tenemos una fecha de pago diferente a hoy, recalcular recargos
      // De lo contrario, usar los valores que retorna el backend (calculados con hoy)
      if (Array.isArray(adeudosRaw) && fechaPago && categoriasRecargo.length > 0) {
        adeudosRaw = adeudosRaw.map((adeudo) => {
          // Si no viene 'categoria' pero sí 'nombre_categoria', copiarlo
          let categoria = adeudo.categoria;
          if (!categoria && adeudo.nombre_categoria) {
            categoria = adeudo.nombre_categoria;
          }
          let recargo = 0;
          // Buscar la categoría del adeudo usando la regla estricta de match
          const cat = categoriasRecargo.find(c => matchCategoriaRecargo(adeudo, c));
          if (cat) {
            try {
              const fp = parseToDate(fechaPago);
              const fv = parseToDate(adeudo.fecha_vencimiento || adeudo.fecha_vencimiento_iso);
              if (fp && fv) {
                // Si el campus es Teran, no aplicar recargo
                recargo = campusEsTeran ? 0 : (calcularRecargoCategoria(cat, fp, fv) || 0);
              }
            } catch (e) {
              console.error('Error calculando recargo en loadAdeudos:', e);
            }
          }
          return { ...adeudo, categoria, monto_recargo: recargo };
        });
      }
      
      setAdeudos(adeudosRaw);
    } catch (err) {
      console.error('Error al cargar adeudos:', err);
      setError('No se pudieron cargar los adeudos pendientes');
    } finally {
      setLoading(false);
    }
  };

  const handleDeleteCharge = async (cargoId, concepto) => {
    // Confirmar antes de eliminar
    const confirmar = window.confirm(
      `¿Está seguro de que desea eliminar el cargo "${concepto}"?\n\nEsta acción no se puede deshacer.`
    );

    if (!confirmar) return;

    setDeletingId(cargoId);
    setError(null);

    try {
      const response = await eliminarCargo(cargoId);
      
      if (response.success) {
        // Actualizar lista de adeudos
        setAdeudos(adeudos.filter(a => a.id !== cargoId));
        
        // Notificar al componente padre
        if (onChargeDeleted) {
          onChargeDeleted(cargoId);
        }
      } else {
        setError(response.error || 'Error al eliminar el cargo');
      }
    } catch (err) {
      console.error('Error al eliminar cargo:', err);
      setError(err.message || 'Error al eliminar el cargo');
    } finally {
      setDeletingId(null);
    }
  };

  // Calcular totales
  const totalAdeudos = adeudos.reduce((sum, adeudo) => sum + parseFloat(adeudo.saldo_pendiente || 0), 0);
  const totalMontoPagado = adeudos.reduce((sum, adeudo) => sum + parseFloat(adeudo.monto_pagado || 0), 0);
  const totalMontoNeto = adeudos.reduce((sum, adeudo) => sum + parseFloat(adeudo.monto_neto || 0), 0);
  const totalMontoOriginal = adeudos.reduce((sum, adeudo) => sum + parseFloat(adeudo.monto_original || 0), 0);
  const totalDescuentoBeca = adeudos.reduce((sum, adeudo) => sum + parseFloat(adeudo.descuento_beca_monto || 0), 0);
  const totalSeleccionado = selectedCargos.reduce((sum, c) => sum + (c.monto_aplicado || 0), 0);

  // Helper: obtener nombre normalizado de una categoría (solo campo 'categoria')
    const getCategoriaNombreNormalizada = (cat) => {
      if (!cat) return '';
      return String(cat.categoria).trim().toUpperCase();
    };

    // Helper: buscar coincidencia entre adeudo y categoría de recargo
    // Regla: SOLO aplicar recargo cuando haya coincidencia exacta contra la tabla
    // de categorías. Prioridad de match:
    //   1) Por código de concepto (codigo/codigo_concepto)
    //   2) Si no hay código, por nombre de categoría (categoria/nombre_categoria/subcategoria)
    // IMPORTANTE: Solo aplica recargo a conceptos con categoría 'PARCIALIDADES' (P1-P5)
    const matchCategoriaRecargo = (adeudo, cat) => {
      if (!adeudo || !cat) return false;

      // Validación 1: Solo aplicar recargo a conceptos PARCIALIDADES
      const categoriaConcepto = normalizeText(
        adeudo.categoria_concepto || adeudo.categoria || adeudo.nombre_categoria || ''
      );
      if (categoriaConcepto && !categoriaConcepto.includes('PARCIALIDADES')) {
        return false;
      }

      const adeudoCodigo = normalizeText(
        adeudo.codigo || adeudo.codigo_concepto || adeudo.clave || adeudo.code || ''
      );
      const catCodigo = normalizeText(
        cat.codigo || cat.codigo_concepto || cat.clave || cat.code || ''
      );

      // Si ambos tienen código definido, exigir coincidencia exacta por código
      if (adeudoCodigo && catCodigo) {
        return adeudoCodigo === catCodigo;
      }

      // Si no hay código en alguno, usar coincidencia estricta por categoría
      const adeudoCat = normalizeText(
        adeudo.categoria || adeudo.nombre_categoria || adeudo.subcategoria || ''
      );
      const catCat = normalizeText(
        cat.categoria || cat.nombre_categoria || cat.subcategoria || ''
      );

      if (adeudoCat && catCat && adeudoCat === catCat) {
        return true;
      }

      // En cualquier otro caso, NO aplicar recargo
      return false;
    };

  // Helper: normalizar texto para comparación (quita acentos, espacios y pasa a mayúsculas)
  const normalizeText = (s) => {
    if (!s && s !== 0) return '';
    return String(s).normalize('NFD').replace(/\p{Diacritic}/gu, '').replace(/\s+/g, ' ').trim().toUpperCase();
  };

  // Buscar categoría recargo coincidente con adeudo usando varios campos posibles
  const findCategoriaForAdeudo = (adeudo) => {
    if (!adeudo || categoriasRecargo.length === 0) return null;
    const candidates = categoriasRecargo;
    const adeudoFields = [
      adeudo.categoria,
      adeudo.nombre_categoria,
      adeudo.subcategoria,
      adeudo.codigo,
      adeudo.concepto,
      adeudo.tipo_cargo
    ].map(normalizeText).filter(Boolean);

    for (const cat of candidates) {
      const catFields = [
        cat.categoria,
        cat.nombre_categoria,
        cat.subcategoria,
        cat.codigo,
        cat.name,
        cat.nombre
      ].map(normalizeText).filter(Boolean);

      if (catFields.some(cf => adeudoFields.includes(cf))) return cat;
    }

    return null;
  };

  // Helper: parsear una fecha que puede venir en 'DD/MM/YYYY' o 'YYYY-MM-DD' o como Date
  const parseToDate = (f) => {
    if (!f) return null;
    if (f instanceof Date) return f;
    const s = String(f).trim();
    // Formato DD/MM/YYYY
    const matchDMY = s.match(/^(\d{1,2})\/(\d{1,2})\/(\d{4})$/);
    if (matchDMY) {
      const d = parseInt(matchDMY[1], 10);
      const m = parseInt(matchDMY[2], 10) - 1;
      const y = parseInt(matchDMY[3], 10);
      return new Date(y, m, d);
    }
    // Formato YYYY-MM-DD or ISO
    const isoMatch = s.match(/^(\d{4})-(\d{1,2})-(\d{1,2})/);
    if (isoMatch) {
      return new Date(s);
    }
    // Ultimo recurso: Date constructor
    const d = new Date(s);
    return isNaN(d.getTime()) ? null : d;
  };

  // Simulación: array de categorías con datos de recargo (en producción, hacer fetch de la tabla 'categorias')


  let totalRecargos = 0;
  if (selectedCargos && selectedCargos.length > 0 && conceptos.length > 0 && categoriasRecargo.length > 0 && adeudos.length > 0 && fechaPago) {
    // Tomar el primer cargo seleccionado
    const primerCargo = selectedCargos[0];
    // Buscar el adeudo correspondiente
    const adeudo = adeudos.find(a => a.id === primerCargo.id_cargo);
    console.log('[RECARGO] Adeudo seleccionado:', adeudo);
    if (adeudo) {
      // Buscar el concepto usando el codigo del adeudo
      const codigoAdeudo = String(adeudo.codigo || adeudo.codigo_concepto || '').trim().toUpperCase();
      const concepto = conceptos.find(c => {
        const codigoCat = String(c.codigo || '').trim().toUpperCase();
        return codigoCat && codigoAdeudo && codigoCat === codigoAdeudo;
      });
      console.log('[RECARGO] Concepto encontrado:', concepto);
      if (concepto) {
        // Buscar la categoría de recargo por nombre_categoria
        const categoriaConcepto = concepto.categoria;
        const categoriaRecargo = categoriasRecargo.find(cat => String(cat.categoria || cat.nombre_categoria).trim().toUpperCase() === String(categoriaConcepto).trim().toUpperCase());
        console.log('[RECARGO] categoriaRecargo encontrada:', categoriaRecargo);
        if (categoriaRecargo) {
          try {
            console.log('[RECARGO] Llamando calcularRecargoCategoria con (raw):', categoriaRecargo, fechaPago, adeudo.fecha_vencimiento);
            const fp = parseToDate(fechaPago);
            const fv = parseToDate(adeudo.fecha_vencimiento);
            console.log('[RECARGO] fechas parseadas:', { fp, fv });
            totalRecargos = calcularRecargoCategoria(categoriaRecargo, fp || fechaPago, fv || adeudo.fecha_vencimiento) || 0;
            console.log('[RECARGO] Resultado calcularRecargoCategoria:', totalRecargos);
          } catch (err) {
            console.error('Error calculando recargo único:', err);
            totalRecargos = 0;
          }
        } else {
          console.warn('[RECARGO] No se encontró categoría de recargo para:', categoriaConcepto);
        }
      } else {
        console.warn('[RECARGO] No se encontró concepto para el codigo:', codigoAdeudo);
      }
    }
  }

  // Si no hay cargos seleccionados, usar el recargo calculado/proporcionado desde el padre (`recargoMap`)
  const recargosFromMap = Object.values(recargoMap || {}).reduce((s, v) => s + (parseFloat(v) || 0), 0);

  // Estado para recargos calculados automáticamente al cargar la sección
  const [autoRecargos, setAutoRecargos] = useState(0);
  // Estado para recargos por adeudo (por id)
  const [recargosById, setRecargosById] = useState({});

  // Calcular total de la columna 'Recargo' sumando lo que se muestra por fila
  const getRecargoVisibleForAdeudo = (adeudo) => {
    // Si el campus es Teran, siempre mostrar 0
    if (campusEsTeran) return 0;

    const tieneRecargoMapPadre = recargoMap && Object.prototype.hasOwnProperty.call(recargoMap, adeudo.id);
    const recargoDesdeMapPadre = tieneRecargoMapPadre
      ? Number(recargoMap[adeudo.id]) || 0
      : null;

    const tieneRecargoCalculado = recargosById && Object.prototype.hasOwnProperty.call(recargosById, adeudo.id);
    const recargoCalculadoFila = tieneRecargoCalculado
      ? Number(recargosById[adeudo.id]) || 0
      : null;

    const tieneRecargoBackend = adeudo.monto_recargo !== undefined && adeudo.monto_recargo !== null;
    const recargoGuardadoAdeudo = tieneRecargoBackend ? Number(adeudo.monto_recargo) || 0 : null;

    // Prioridad:
    // 1) Valor proveniente del padre (recargoMap), aunque sea 0
    if (tieneRecargoMapPadre) {
      return recargoDesdeMapPadre || 0;
    }
    // 2) Valor calculado en este componente (recargosById), aunque sea 0
    if (tieneRecargoCalculado) {
      return recargoCalculadoFila || 0;
    }
    // 3) Solo si no tenemos cálculo local, usar el que viene del backend
    if (tieneRecargoBackend) {
      return recargoGuardadoAdeudo || 0;
    }

    return 0;
  };

  // Sumar recargo solo de los adeudos seleccionados
  const totalRecargoSeleccionados = selectedCargos.reduce((sum, c) => {
    const adeudo = adeudos.find(a => a.id === c.id_cargo);
    return adeudo ? sum + getRecargoVisibleForAdeudo(adeudo) : sum;
  }, 0);

  // Recalcular recargos automáticos cuando cambian adeudos, categorias o fechaPago
  useEffect(() => {
    if (!fechaPago || categoriasRecargo.length === 0 || adeudos.length === 0) {
      setAutoRecargos(0);
      return;
    }

    let total = 0;
    for (const adeudo of adeudos) {
      const adeudoCatNorm = String(adeudo.categoria || adeudo.nombre_categoria || '').trim().toUpperCase();
      const cat = categoriasRecargo.find(c => matchCategoriaRecargo(adeudo, c));
      if (!cat) continue;
                try {
        const fp = parseToDate(fechaPago);
        const fv = parseToDate(adeudo.fecha_vencimiento);
        if (!fp || !fv) console.debug('[autoRecargos] fechas inválidas:', { fechaPago, fecha_vencimiento: adeudo.fecha_vencimiento });
                // Si el campus es Teran, ignorar recargos
                total += campusEsTeran ? 0 : (calcularRecargoCategoria(cat, fp || fechaPago, fv || adeudo.fecha_vencimiento) || 0);
      } catch (err) {
        console.error('Error calculando recargo para adeudo en useEffect:', adeudo, err);
      }
    }

    setAutoRecargos(total);
  }, [adeudos, categoriasRecargo, fechaPago]);

  // Recalcular recargos por fila y guardarlos en `recargosById`
  useEffect(() => {
    if (!fechaPago || categoriasRecargo.length === 0 || adeudos.length === 0) {
      const empty = {};
      // Evitar llamadas repetidas si ya es vacío
      const prev = prevMapaRef.current;
      if (JSON.stringify(prev) !== JSON.stringify(empty)) {
        setRecargosById(empty);
        prevMapaRef.current = empty;
        if (onRecargosByIdChange) onRecargosByIdChange(empty);
      }
      return;
    }

    const mapa = {};
    for (const adeudo of adeudos) {
      try {
        // prioridad: recargoMap proporcionado por el padre > cálculo automático
        // Si el campus es Teran, forzar 0 para todos los recargos
        if (campusEsTeran) {
          mapa[adeudo.id] = 0;
          continue;
        }
        const tieneValEnMapaPadre = recargoMap && Object.prototype.hasOwnProperty.call(recargoMap, adeudo.id);
        if (tieneValEnMapaPadre) {
          // Respetar siempre lo que mande el padre, incluso si es 0
          mapa[adeudo.id] = Number(recargoMap[adeudo.id]) || 0;
          continue;
        }

        const cat = categoriasRecargo.find(c => matchCategoriaRecargo(adeudo, c));
        if (!cat) {
          // Si el adeudo NO tiene categoría de recargo configurada, este adeudo no lleva recargo
          mapa[adeudo.id] = 0;
          continue;
        }

        // Calcular recargo solo cuando hay categoría válida
        const fp = parseToDate(fechaPago);
        const fv = parseToDate(adeudo.fecha_vencimiento);
        const nuevoRecargo = calcularRecargoCategoria(cat, fp || fechaPago, fv || adeudo.fecha_vencimiento) || 0;
        mapa[adeudo.id] = nuevoRecargo || 0;
      } catch (err) {
        console.error('Error calculando recargo por fila en useEffect:', err, adeudo);
        // Ante error en el cálculo, por seguridad NO aplicar recargo automático
        mapa[adeudo.id] = 0;
      }
    }

    const prev = prevMapaRef.current;
    if (JSON.stringify(prev) !== JSON.stringify(mapa)) {
      setRecargosById(mapa);
      prevMapaRef.current = mapa;
      if (onRecargosByIdChange) onRecargosByIdChange(mapa);
      // Exponer en window para que componentes externos puedan leer el mapa inmediatamente
      if (typeof window !== 'undefined') {
        try { window.__lastRecargosById = mapa; } catch (e) { /* ignore */ }
      }
    }
  }, [adeudos, categoriasRecargo, fechaPago, recargoMap]);

  // Asegurar que cada adeudo tenga su `monto_recargo` actualizado cuando cambian las categorías o la fecha de pago.
  useEffect(() => {
    if (!fechaPago || categoriasRecargo.length === 0 || adeudos.length === 0) return;

    let anyChanged = false;
    const updated = adeudos.map((adeudo) => {
      const adeudoCatNorm = String(adeudo.categoria || adeudo.nombre_categoria || '').trim().toUpperCase();
      const cat = categoriasRecargo.find(c => matchCategoriaRecargo(adeudo, c));

      let newRecargo = adeudo.monto_recargo !== undefined && adeudo.monto_recargo !== null ? parseFloat(adeudo.monto_recargo) || 0 : 0;

      // Si no viene precalculado o es 0, calcularlo dinámicamente
      if ((!newRecargo || newRecargo === 0) && cat) {
        try {
          const fp = parseToDate(fechaPago);
          const fv = parseToDate(adeudo.fecha_vencimiento);
          // Si el campus es Teran, no aplicar recargo
          newRecargo = campusEsTeran ? 0 : (calcularRecargoCategoria(cat, fp || fechaPago, fv || adeudo.fecha_vencimiento) || 0);
        } catch (e) {
          console.error('Error recalculando recargo en useEffect por fila:', e);
          newRecargo = 0;
        }
      }

      if ((adeudo.monto_recargo || 0) !== newRecargo) {
        anyChanged = true;
        return { ...adeudo, monto_recargo: newRecargo };
      }

      return adeudo;
    });

    if (anyChanged) setAdeudos(updated);
  }, [categoriasRecargo, fechaPago]);

  // Prioridad: suma de recargos de los cargos seleccionados
  const displayRecargos = (selectedCargos && selectedCargos.length > 0)
    ? totalRecargoSeleccionados
    : (recargosFromMap > 0 ? recargosFromMap : autoRecargos);

  // No mostrar si no hay estudiante seleccionado
  if (!studentId) return null;

  // Expose displayRecargos globally for ChargeForm parent
  window.__lastDisplayRecargos = displayRecargos;

  return (
    <div className={styles.pendingChargesSection}>
      {/* Header de la sección */}
      <div className={styles.pendingChargesHeader}>
        <div className={styles.pendingChargesIcon}>
          <svg viewBox="0 0 24 24" fill="currentColor" width="20" height="20">
            <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm1 15h-2v-2h2v2zm0-4h-2V7h2v6z"/>
          </svg>
        </div>
        <h3 className={styles.pendingChargesTitle}>
          Adeudos Pendientes del Estudiante (Seleccione los conceptos a pagar)
        </h3>
        
        <button
          type="button"
          onClick={handleRecalcularBecas}
          disabled={recalculating || loading}
          style={{
            marginLeft: 'auto',
            display: 'flex',
            alignItems: 'center',
            gap: '6px',
            backgroundColor: '#002f6c',
            color: '#ffffff',
            border: 'none',
            borderRadius: '4px',
            padding: '6px 12px',
            cursor: (recalculating || loading) ? 'not-allowed' : 'pointer',
            fontSize: '11px',
            fontWeight: '700',
            fontFamily: "'Roboto', sans-serif",
            textTransform: 'uppercase',
            opacity: (recalculating || loading) ? 0.7 : 1,
            transition: 'background-color 0.2s'
          }}
          onMouseOver={(e) => { if (!recalculating && !loading) e.target.style.backgroundColor = '#001c44'; }}
          onMouseOut={(e) => { if (!recalculating && !loading) e.target.style.backgroundColor = '#002f6c'; }}
        >
          <style>{`
            @keyframes spin-beca {
              0% { transform: rotate(0deg); }
              100% { transform: rotate(360deg); }
            }
          `}</style>
          <svg viewBox="0 0 24 24" fill="currentColor" width="14" height="14" style={{ 
            animation: recalculating ? 'spin-beca 1s linear infinite' : 'none' 
          }}>
            <path d="M17.65 6.35C16.2 4.9 14.21 4 12 4c-4.42 0-7.99 3.58-7.99 8s3.57 8 7.99 8c3.73 0 6.84-2.55 7.73-6h-2.08c-.82 2.33-3.04 4-5.65 4-3.31 0-6-2.69-6-6s2.69-6 6-6c1.66 0 3.14.69 4.22 1.78L13 11h7V4l-2.35 2.35z"/>
          </svg>
          {recalculating ? 'RECALCULANDO...' : 'Recalcular Descuentos de Becas'}
        </button>
      </div>

      {/* Error message */}
      {error && (
        <div className={styles.pendingChargesError}>
          {error}
        </div>
      )}

      {/* Loading state */}
      {loading ? (
        <div className={styles.pendingChargesLoading}>
          Cargando adeudos pendientes...
        </div>
      ) : adeudos.length === 0 ? (
        <div className={styles.pendingChargesEmpty}>
          El estudiante no tiene adeudos pendientes.
        </div>
      ) : (
        <>
          {/* Tabla de adeudos */}
          <div className={styles.pendingChargesTable}>
            <div className={styles.pendingChargesTableScroll}>
            <div className={styles.pendingChargesTableHeader}>
              <div className={styles.pendingChargesHeaderCell}>Sel.</div>
              <div className={styles.pendingChargesHeaderCell}>Ciclo</div>
              <div className={styles.pendingChargesHeaderCell}>Concepto</div>
              <div className={styles.pendingChargesHeaderCell}>Código</div>
              <div className={styles.pendingChargesHeaderCell}>Beca</div>
              <div className={styles.pendingChargesHeaderCell}>Descripción</div>
              <div className={styles.pendingChargesHeaderCell}>Vencimiento</div>
              <div className={styles.pendingChargesHeaderCell}>Recargo</div>
              <div className={styles.pendingChargesHeaderCell}>Monto Original</div>
              <div className={styles.pendingChargesHeaderCell}>Desc. Beca</div>
              <div className={styles.pendingChargesHeaderCell}>Desc. Bonif.</div>
              <div className={styles.pendingChargesHeaderCell}>Desc. Condo.</div>
              <div className={styles.pendingChargesHeaderCell}>Monto Neto</div>
              <div className={styles.pendingChargesHeaderCell}>Pagado</div>
              <div className={styles.pendingChargesHeaderCell}>Saldo</div>
              <div className={styles.pendingChargesHeaderCell}>Recargo</div>
              <div className={styles.pendingChargesHeaderCell}>A Aplicar</div>
              <div className={styles.pendingChargesHeaderCell}>Acciones</div>
            </div>

            <div className={styles.pendingChargesTableBody}>
              {[...adeudos].map((adeudo) => {

                // Forzar re-render cuando cambia fechaPago
                // eslint-disable-next-line no-unused-vars
                const _forceFechaPago = fechaPago;
                const isSelected = selectedCargos.find(c => c.id_cargo === adeudo.id);
                const montoAplicar = isSelected ? isSelected.monto_aplicado : 0;

                // Obtener el recargo calculado desde el estado `recargosById` (o recargoMap/adeudo como fallback)
                const tieneRecargoMapPadre = recargoMap && Object.prototype.hasOwnProperty.call(recargoMap, adeudo.id);
                const recargoDesdeMapPadre = tieneRecargoMapPadre
                  ? Number(recargoMap[adeudo.id]) || 0
                  : null;
                const tieneRecargoCalculado = recargosById && Object.prototype.hasOwnProperty.call(recargosById, adeudo.id);
                const recargoCalculadoFila = tieneRecargoCalculado
                  ? Number(recargosById[adeudo.id]) || 0
                  : null;
                const tieneRecargoBackend = adeudo.monto_recargo !== undefined && adeudo.monto_recargo !== null;
                const recargoGuardadoAdeudo = tieneRecargoBackend ? Number(adeudo.monto_recargo) || 0 : null;

                // Prioridad visual por fila (misma regla que getRecargoVisibleForAdeudo):
                // 1) recargoMap del padre, aunque sea 0
                // 2) recargosById calculado en este componente
                // 3) monto_recargo que venga del backend solo si no hay cálculo local
                let mostrarRecargo = 0;
                if (tieneRecargoMapPadre) {
                  mostrarRecargo = recargoDesdeMapPadre || 0;
                } else if (tieneRecargoCalculado) {
                  mostrarRecargo = recargoCalculadoFila || 0;
                } else if (tieneRecargoBackend) {
                  mostrarRecargo = recargoGuardadoAdeudo || 0;
                }

                // Debug: mostrar valores de recargo por fila
                console.log('[RECARGO-FILA]', {
                  id: adeudo.id,
                  concepto: adeudo.concepto,
                  fecha_vencimiento: adeudo.fecha_vencimiento,
                  recargoDesdeMapPadre,
                  recargoCalculadoFila,
                  recargoGuardadoAdeudo,
                  mostrarRecargo,
                  categoria: adeudo.categoria,
                  nombre_categoria: adeudo.nombre_categoria,
                  saldo_pendiente: adeudo.saldo_pendiente,
                  monto_neto: adeudo.monto_neto,
                  monto_pagado: adeudo.monto_pagado
                });

                return (
                <div key={adeudo.id} className={styles.pendingChargesTableRow}>
                  <div className={styles.pendingChargesTableCell}>
                    <input
                      type="checkbox"
                      checked={!!isSelected}
                      onChange={() => handleCargoSelection(adeudo.id, adeudo.saldo_pendiente)}
                      disabled={parseFloat(adeudo.saldo_pendiente) <= 0}
                    />
                  </div>
                  <div className={styles.pendingChargesTableCell}>
                    {ciclosMap[adeudo.id_ciclo_escolar] || adeudo.id_ciclo_escolar || '-'}
                  </div>
                  <div className={styles.pendingChargesTableCell}>
                    {adeudo.concepto}
                  </div>
                  <div className={styles.pendingChargesTableCell} style={{ fontSize: '12px', fontWeight: 'bold', color: '#002f6c' }}>
                    {adeudo.codigo_concepto || adeudo.codigo || '-'}
                  </div>
                  <div className={styles.pendingChargesTableCell} style={{ fontSize: '11px' }}>
                    {adeudo.beca && adeudo.beca.nombre_beca ? (
                      <div style={{ whiteSpace: 'normal', lineHeight: '1.2' }}>
                        <strong>{adeudo.beca.nombre_beca}</strong>
                        <br />
                        <small style={{ color: '#666' }}>
                          {adeudo.beca.porcentaje_otorgado 
                            ? `${adeudo.beca.porcentaje_otorgado}%` 
                            : adeudo.beca.monto_beca_calculado 
                              ? `$${parseFloat(adeudo.beca.monto_beca_calculado).toFixed(2)}`
                              : '-'
                          }
                        </small>
                      </div>
                    ) : '-'}
                  </div>
                  <div className={styles.pendingChargesTableCell}>
                    {adeudo.descripcion}
                  </div>
                  <div className={styles.pendingChargesTableCell}>
                    {adeudo.fecha_vencimiento || formatearFecha(adeudo.fecha_vencimiento_iso) || '-'}
                  </div>
                  <div className={styles.pendingChargesTableCell}>
                    {formatearMonto(mostrarRecargo || 0)}
                  </div>
                  <div className={styles.pendingChargesTableCell}>
                    {formatearMonto(adeudo.monto_original)}
                  </div>
                  <div className={styles.pendingChargesTableCell} style={{ color: adeudo.descuento_beca_monto > 0 ? '#10b981' : 'inherit' }}>
                    {formatearMonto(adeudo.descuento_beca_monto || 0)}
                  </div>
                  <div className={styles.pendingChargesTableCell} style={{ color: adeudo.descuento_bonificacion > 0 ? '#3b82f6' : 'inherit' }}>
                    {formatearMonto(adeudo.descuento_bonificacion || 0)}
                  </div>
                  <div className={styles.pendingChargesTableCell} style={{ color: adeudo.descuento_condonacion > 0 ? '#8b5cf6' : 'inherit' }}>
                    {formatearMonto(adeudo.descuento_condonacion || 0)}
                  </div>
                  <div className={styles.pendingChargesTableCell}>
                    {formatearMonto(adeudo.monto_neto)}
                  </div>
                  <div className={styles.pendingChargesTableCell}>
                    {formatearMonto(adeudo.monto_pagado)}
                  </div>
                  <div className={styles.pendingChargesTableCell}>
                    {formatearMonto(adeudo.saldo_pendiente)}
                  </div>
                  <div className={styles.pendingChargesTableCell}>
                    {formatearMonto(mostrarRecargo || 0)}
                  </div>
                  <div className={styles.pendingChargesTableCell}>
                    {isSelected ? (
                      formatearMonto(montoAplicar)
                    ) : (
                      '-'
                    )}
                  </div>
                  <div className={styles.pendingChargesTableCell}>
                    <button
                      className={styles.deleteChargeButton}
                      onClick={() => handleDeleteCharge(adeudo.id, adeudo.concepto)}
                      disabled={deletingId === adeudo.id || parseFloat(adeudo.monto_pagado) > 0}
                      title={
                        parseFloat(adeudo.monto_pagado) > 0
                          ? 'No se puede eliminar un cargo con pagos aplicados'
                          : 'Eliminar cargo'
                      }
                    >
                      {deletingId === adeudo.id ? (
                        <span className={styles.deleteButtonLoading}>...</span>
                      ) : (
                        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" width="18" height="18">
                          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16" />
                        </svg>
                      )}
                    </button>
                  </div>
                </div>
              )})}
            </div>
            </div>

            {/* Footer con totales */}
            <div className={styles.pendingChargesTableFooter}>
              <div className={styles.pendingChargesTotals}>
                <div className={styles.pendingChargesTotalItem}>
                  <span className={styles.pendingChargesTotalLabel}>Monto original:</span>
                  <span className={styles.pendingChargesTotalValue}>{formatearMonto(totalMontoOriginal)}</span>
                </div>
                {totalDescuentoBeca > 0 && (
                  <div className={styles.pendingChargesTotalItem}>
                    <span className={styles.pendingChargesTotalLabel} style={{color: '#10b981'}}>🎓 Descuento becas:</span>
                    <span className={styles.pendingChargesTotalValue} style={{color: '#10b981'}}>-{formatearMonto(totalDescuentoBeca)}</span>
                  </div>
                )}
                <div className={styles.pendingChargesTotalItem}>
                  <span className={styles.pendingChargesTotalLabel}>Total adeudos:</span>
                  <span className={styles.pendingChargesTotalValue}>{formatearMonto(totalMontoNeto)}</span>
                </div>
                <div className={styles.pendingChargesTotalItem}>
                  <span className={styles.pendingChargesTotalLabel}>Monto pagado:</span>
                  <span className={styles.pendingChargesTotalValue}>{formatearMonto(totalMontoPagado)}</span>
                </div>
                <div className={styles.pendingChargesTotalItem}>
                  <span className={styles.pendingChargesTotalLabel}>Saldo pendiente:</span>
                  <span className={styles.pendingChargesTotalValueHighlight}>{formatearMonto(totalAdeudos)}</span>
                </div>
                <div className={styles.pendingChargesTotalItem}>
                  <span className={styles.pendingChargesTotalLabel} style={{color: '#ed8b00', fontWeight: 'bold'}}>✓ Monto seleccionado:</span>
                  <span className={styles.pendingChargesTotalValueHighlight} style={{color: '#ed8b00'}}>{formatearMonto(totalSeleccionado)}</span>
                </div>
                <div className={styles.pendingChargesTotalItem}>
                  <span className={styles.pendingChargesTotalLabel}>Recargo:</span>
                  <span className={styles.pendingChargesTotalValue}>{formatearMonto(totalRecargoSeleccionados)}</span>
                </div>
                
              </div>
            </div>
          </div>
        </>
      )}
    </div>
  );
}

export default PendingChargesSection;
